import { createAction, props } from '@ngrx/store';
import { Product } from 'src/typings';

export const addToCart = createAction('ADD_PRODUCT', props<{ payload: Product }>());
export const removeFromCart = createAction('REMOVE_FROM_CART', props<{ payload: Product }>());
export const clearCart = createAction('CLEAR_CART');
export const updateProductInCart = createAction(
  'UPDATE_PRODUCT_IN_CART',
  props<{ payload: Product; quan: number; retail?: number }>()
);
export const updateCart = createAction(
  'UPDATE_CART',
  props<{ payload: { product: Product; quan: number; retail: number }[] }>()
);
